import React, { useState, useEffect } from 'react';
import CategoryCard from '../components/CategoryCard';
import Loader from '../components/Loader';
import ErrorMessage from '../components/ErrorMessage';
import apiService from '../services/api';
import '../styles/global.css';

export default function Menu() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await apiService.getCategories();
      setCategories(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Failed to load categories');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Our Menu</h1>

          {loading ? (
            <Loader />
          ) : error ? (
            <ErrorMessage message={error} onRetry={fetchCategories} />
          ) : categories.length === 0 ? (
            <div className="error-message" style={{ marginTop: '2rem' }}>
              <p>No categories available at the moment</p>
            </div>
          ) : (
            <div className="grid grid-2">
              {categories.map((category) => (
                <CategoryCard
                  key={category.id}
                  id={category.id}
                  name={category.name}
                  image={category.image}
                />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
